// extracted by mini-css-extract-plugin
export default {"text_input":"TextInput_text_input__JYlOP","input_box":"TextInput_input_box__hTRcq","text_input_box":"TextInput_text_input_box__lAlAl"};